import { isLate } from '../utils/format';

export function RatioBadge({ r }) {
  const color = r >= 100 ? 'var(--ok)' : r >= 50 ? 'var(--warn)' : 'var(--danger)';
  return <span style={{ color, fontWeight: 700 }}>{r}%</span>;
}

export function StatusChip({ task }) {
  if (isLate(task) && task.status !== 'done') return <span className="chip late">Trễ hạn</span>;
  const map = {
    pool: ['todo', 'Chờ giao'],
    pending_confirm: ['review', 'Chờ TP xác nhận'],
    assigned: ['doing', 'Đã giao'],
    doing: ['doing', 'Đang làm'],
    review: ['review', 'Chờ duyệt'],
    done: ['done', 'Hoàn thành'],
  };
  const [cls, label] = map[task.status] || ['todo', task.status];
  return <span className={`chip ${cls}`}>{label}</span>;
}

export function KpiPct({ p }) {
  let color = 'var(--text)';
  if (p >= 80) color = 'var(--ok)';
  else if (p >= 50) color = 'var(--warn)';
  else color = 'var(--danger)';
  return <span style={{ color, fontWeight: 700 }}>{p}%</span>;
}
